import { ɵɵinject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService =  ɵɵinject(AuthService);
  const router =  ɵɵinject(Router);
  if(!authService.loggedIn()){
    router.navigateByUrl('signin') 
  }
  return true;
};
